export enum RulesName {
  OneQuestionOneCalculation = 'OneQuestionOneCalculation',
  OneQuestionManyCalculations = 'OneQuestionManyCalculations',
  ManyCalculations = 'ManyCalculations',
  ManyQuestions = 'ManyQuestions',
  OneQuestion = 'OneQuestion',
}
